const isDev = window.location.port === '3000';

const loadSingleProductScripts = async () => {
    const { toggleProductTabs } = await import("./modules/single-product/toggle-product-tabs");
    toggleProductTabs();
};

window.addEventListener("load", () => {
    const body = document.querySelector('body');

    if (body.id === "product") {
        loadSingleProductScripts();

        if (isDev) {
            import('../scss/pages/single-product.scss');
        }
    };
});

if (module.hot) {
  module.hot.accept();
  console.log('[HMR] Module hot accepted!');
}
